import { registerPlugin } from '@capacitor/core';
import type { InstallCheckOutcome } from '@shared/types/attribution';

export interface InstallAttributionData {
    /** Attribution source: 'google-play', 'apple-search-ads', or 'unknown' */
    source: string;
    /** Full referrer string (Android) or campaign name (iOS) */
    referrer?: string;
    /** UTM params parsed from referrer (Android) */
    utmSource?: string;
    utmMedium?: string;
    utmCampaign?: string;
    utmContent?: string;
    utmTerm?: string;
    /** Google click ID from auto-tagging (Android) */
    gclid?: string;
    /** Apple Search Ads fields (iOS) */
    campaignId?: string;
    campaignName?: string;
    adGroupId?: string;
    adGroupName?: string;
    keyword?: string;
    /** Whether attribution data was found */
    attributed: boolean;
    /**
     * Optional coarse outcome of the check. Native may set this in the future
     * (e.g. to distinguish a transient `unavailable`/`error` from a real `organic`
     * install); when absent the TS layer derives it from this result.
     */
    checkOutcome?: InstallCheckOutcome;
}

export interface InstallAttributionPlugin {
    /** Get install attribution data. Returns empty result on web. */
    getData(): Promise<InstallAttributionData>;
}

const InstallAttribution = registerPlugin<InstallAttributionPlugin>('InstallAttribution', {
    web: () => Promise.resolve({
        getData: async () => ({ source: 'web', attributed: false }),
    }),
});

export default InstallAttribution;
